module.exports = __webpack_public_path__ + "static/img/net.93593344.png";